import featureSaga from './sagas/FeatureSaga';
import roleSaga from './sagas/RoleSaga';
export default [
    featureSaga,
    roleSaga
];